import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Select, Tooltip, Row, Col, Button, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { requiredFieldRule } from "../../../components/RequiredFieldRule";
import "../../layout/Style.css";
import { getModalSizeByWindowSize } from "../../layout/Constants";
import AddDepartmentForm from "../../manage/Departments/AddDepartmentForm";
import {
  fetchDepartments,
  saveDepartment,
} from "../../../api/redux/action/DepartmentActions";
import { fetchUserGroups } from "../../../api/redux/action/UserGroupActions";
import { ElementIDS } from "../../../components/common/ElementsIDs";
import validator from "validator";
const { Option } = Select;

const AddUserForm = (props) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState({ department: false });
  const [departmentForm] = Form.useForm();
  const [newDepartmentData, setNewDepartmentData] = useState(undefined);
  const [modalSize, setModalSize] = useState(getModalSizeByWindowSize());
  const [sortedDepartments, setSortedDepartments] = useState([]);
  const [success, setSuccess] = useState("");
  const [selectedDepartments, setSelectedDepartments] = useState();

  const { departments, userGroups, englishLang } = useSelector((store) => ({
    departments: store.departmentReducer.departments,
    userGroups: store.userGroupReducer.userGroups,
    englishLang: store.langReducer.englishLang,
  }));

  useEffect(() => {
    dispatch(fetchDepartments());
  }, [newDepartmentData]);

  useEffect(() => {
    if (
      departments &&
      departments.content &&
      newDepartmentData &&
      newDepartmentData.name
    ) {
      departments.content.map((item) => {
        if (item.name == newDepartmentData.name) {
          props.form.setFieldsValue({
            ...(newDepartmentData && {
              department: item.departmentId,
            }),
          });
        }
      });
    }
  }, [departments]);

  useEffect(() => {
    dispatch(fetchUserGroups());
  }, []);

  useEffect(() => {
    if (departments && departments.content) {
      let sorted = departments.content.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );
      setSortedDepartments(sorted);
    }
  }, [departments]);

  const handleAddNewDepartment = () => {
    showModal(true);
  };

  const handleDepartmentFormSave = (values) => {
    const formData = {
      name: departmentForm.getFieldValue().name,
    };
    if (Object.keys(formData).length > 0) {
      dispatch(saveDepartment(formData))
        .then(() => {
          setNewDepartmentData(values);

          formData = {
            name: departmentForm.resetFields().name,
          };
        })
        .catch((err) => console.log(err));
    }
    setVisible(false);
  };

  const showModal = (department) => {
    setVisible({ department: department });
  };

  const handleModalOk = (e) => {
    departmentForm.submit();
  };

  const handleModalCancel = (e) => {
    setVisible(false);
  };

  return (
    <Form
      labelCol={{ xs: 24, sm: 24, md: 6, lg: 8, xl: 6 }}
      wrapperCol={{ xs: 24, sm: 24, md: 14, lg: 14, xl: 14 }}
      form={props.form}
      name="user-form"
      onFinish={props.handleSave}
    >
      <Form.Item
        id={ElementIDS().name}
        label={props.language?.NAME?.value ?? englishLang?.NAME?.value}
        name="name"
        rules={requiredFieldRule}
      >
        <Input
          onChange={(e) => {
            props.setDirty();
          }}
          disabled={
            props.readOnly && props.readOnly.viewOption ? "disabled" : null
          }
        />
      </Form.Item>
      <Form.Item
        id={ElementIDS().surName}
        label={props.language?.SURNAME?.value ?? englishLang?.SURNAME?.value}
        name="surname"
        rules={requiredFieldRule}
      >
        <Input
          onChange={(e) => {
            props.setDirty();
          }}
          disabled={
            props.readOnly && props.readOnly.viewOption ? "disabled" : null
          }
        />
      </Form.Item>
      <Form.Item
        id={ElementIDS().userName}
        label={props.language?.USERNAME?.value ?? englishLang?.USERNAME?.value}
        name="username"
        rules={[
          {
            required: true,
            message:
              props.language?.REQUIRED_FIELD?.value ??
              englishLang?.REQUIRED_FIELD?.value,
          },
          { type: "email" },
        ]}
      >
        <Input
          disabled={props.edit}
          onChange={(e) => {
            props.setDirty();
          }}
        />
      </Form.Item>
      <Form.Item
        label={
          props.language?.USER_GROUP?.value ?? englishLang?.USER_GROUP?.value
        }
        required
      >
        <Row gutter={3}>
          <Col flex={9}>
            <Form.Item
              id={ElementIDS().userGroup}
              name="userGroup"
              rules={requiredFieldRule}
              noStyle
            >
              <Select
                allowClear
                style={{ width: "100%" }}
                placeholder={
                  props.language?.SELECT_USER_GROUP?.value ??
                  englishLang?.SELECT_USER_GROUP?.value
                }
                showSearch
                onChange={(e) => {
                  props.setDirty();
                }}
                disabled={
                  props.readOnly && props.readOnly.viewOption
                    ? "disabled"
                    : null
                }
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {userGroups && userGroups.content
                  ? userGroups.content.map((item) => (
                      <Option
                        id={ElementIDS().optionUserGroup}
                        key={item.userGroupId}
                        value={item.userGroupId}
                      >
                        {item.name}
                      </Option>
                    ))
                  : undefined}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      <Form.Item
        label={
          props.language?.DEPARTMENT?.value ?? englishLang?.DEPARTMENT?.value
        }
      >
        <Row gutter={3}>
          <Col flex={9} span={22}>
            <Form.Item id={ElementIDS().department} name="department" noStyle>
              <Select
                mode="multiple"
                maxTagCount="responsive"
                as
                const
                allowClear
                style={{ width: "100%" }}
                placeholder={
                  props.language?.SELECT_DEPARTMENT?.value ??
                  englishLang?.SELECT_DEPARTMENT?.value
                }
                showSearch
                value={selectedDepartments}
                onChange={(e) => {
                  props.setDirty();
                  // setSelectedDepartments(e);
                }}
                defaultValue={selectedDepartments}
                disabled={
                  props.readOnly && props.readOnly.viewOption
                    ? "disabled"
                    : null
                }
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {sortedDepartments
                  ? sortedDepartments.map((item) => (
                      <Option
                        id={ElementIDS().optionDepartment}
                        key={item.departmentId}
                        value={item.departmentId}
                      >
                        {item.name}
                      </Option>
                    ))
                  : undefined}
              </Select>
            </Form.Item>
          </Col>
          <Col flex={1} span={2}>
            <Tooltip
              title={
                props.language?.CREATE_NEW_DEPARTMENT?.value ??
                englishLang?.CREATE_NEW_DEPARTMENT?.value
              }
            >
              <Button
                id={ElementIDS().create}
                icon={<PlusOutlined />}
                ghost
                type="primary"
                onClick={handleAddNewDepartment}
                style={{ width: "100%" }}
                disabled={
                  props.readOnly && props.readOnly.viewOption
                    ? "disabled"
                    : null
                }
              />
            </Tooltip>
          </Col>
        </Row>
      </Form.Item>

      <Modal
        title={
          props.language?.ADD_DEPARTMENT?.value ??
          englishLang?.ADD_DEPARTMENT?.value
        }
        open={visible.department}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        width={modalSize}
      >
        <Row justify="center">
          <Col span={20}>
            <AddDepartmentForm
              handleSave={handleDepartmentFormSave}
              form={departmentForm}
              setDirty={props.setDirty}
            />
          </Col>
        </Row>
      </Modal>

      {props.footer}
    </Form>
  );
};

export default AddUserForm;
